import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import type { Shops } from '@/Swagger';
import axiosInstance from '@/axios/axios';

import { 알람_쿼리키 } from './notification-query-keys';

type QueryOpions = UseQueryOptions<
  Shops.NotificationsDetail.ResponseBody,
  AxiosError,
  Shops.NotificationsDetail.ResponseBody,
  [string, { shopID: string; searchParams: Shops.NotificationsDetail.RequestQuery }]
>;

/**
 * 샵의 알람을 가져오는 useQuery 훅
 * @see https://kr-api-qa.acloset.net/shops/swagger/index.html#/Notifications/get_shops__shopID__notifications
 */
export const useQueryGetNotifications = (
  shopID: string,
  searchParams: Shops.NotificationsDetail.RequestQuery,
  options?: Partial<QueryOpions>,
) =>
  useQuery({
    queryKey: [...알람_쿼리키.알람, { shopID, searchParams }],

    queryFn: () =>
      axiosInstance
        .get<Shops.NotificationsDetail.ResponseBody>(`/shops/${shopID}/notifications`, {
          params: searchParams,
        })
        .then(v => v.data),

    ...options,
  });
